import InvestmentIncome from "./InvestmentIncome";

export default InvestmentIncome;
